import {
  NotificationDispatchType,
  SET_NOTIFICATION_UNREAD_COUNT,
} from "../../actions/notification/NotificationActionType";

export interface IDefaultState {
  unreadCount: number;
}

const defaultState: IDefaultState = {
  unreadCount: 0,
};

const NotificationReducer = (
  // eslint-disable-next-line no-restricted-globals
  state: IDefaultState = defaultState,
  action: NotificationDispatchType
): IDefaultState => {
  switch (action.type) {
    case SET_NOTIFICATION_UNREAD_COUNT:
      return {
        ...state,
        unreadCount: action.payload.unreadCount,
      };
    default:
      return state;
  }
};

export default NotificationReducer;
